<template>
  <div>
    <!-- 共通-表示項目・検索条件 設定ダイアログコンポーネント -->
    <!-- :title="", dataGet, select, delete を定義する。emit で渡す必要があれば渡す -->
    <BaseDialog
        title="検索条件設定"
        :visible.sync="dialogVisible"
        width="700px"
        :append-to-body="true"
        @closed="close">
      <template slot="contents">
        <!-- 保存済みのリスト -->
        <BaseTableList
            ref="table"
            class="table"
            row-class-name="clickable"
            :table-set-list="_tableSetList"
            :display-items="displayItem"
            :filter-condition.sync="filterCondition"
            @sort-change="onSortChange"
            @row-dblclick="onRowDoubleClick">
          <template slot="slots"
              slot-scope="{ row }">
            <slot :name="'slots'"
                :row="row" />
          </template>
        </BaseTableList>
        <!-- ページネーション -->
        <div class="base-pagination">
          <el-pagination
              :current-page="currentPage"
              :page-size="10"
              :total="total"
              background
              layout="prev, pager, next, total"
              @current-change="onPaginationCurrentChange" />
        </div>
      </template>
    </BaseDialog>
  </div>
</template>

<style scoped>
</style>
<script>

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseTableList from '@/components/molecules/BaseTableList'
import BaseDialog from '@/components/molecules/BaseDialog'
import common from '@/utils/common'
import message from '@/utils/message'
import * as define from '@/define'
import * as config from '@/config'
import _ from 'lodash'

export default {
  name: 'BaseSearchConditionListModal',
  components: {
    BaseTableList,
    BaseDialog
  },
  inject: ['parentValidator'],
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    storePath: {
      type: String,
      required: true
    },
    functionKey: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      searchConfigData: [],
      currentPage: 1,
      searchKey: '',
      dialogDisplayConfig: [],
      sortCondition: {},
      filterCondition: {}
    }
  },
  computed: {
    store () {
      return this.$store.state[this.storePath] || {}
    },
    searchConditions () {
      return this.store.searchConditions || {}
    },
    _tableSetList () {
      return [
        {
          type: 'String', label: '名前', path: 'name',
          sortable: 'custom', sortBy: 'name'
        },
        {
          type: 'String', label: '公開', elementType: ELEMENT_TYPE.FUNCTION,
          path: (row) => row.account ? '個人' : '公開', width: '150px',
          columnKey: 'isPublic', name: 'isPublic',
          filters: [ { text: '個人', value: 0 }, { text: '公開', value: 1 } ],
          sortable: 'custom', sortBy: (row) => row.account ? 0 : 1
        },
        {
          type: 'String', elementType: ELEMENT_TYPE.CELL, width: '250px',
          properties: [{
            elementType: ELEMENT_TYPE.BUTTON,
            label: '削除', class: 'right',
            click: this.deleteSearchConfig
          }],
          value: '',
          renderHeader: (h, { _self }) => {
            return h('input',
              {
                class: 'el-input__inner',
                attrs: { placeholder: 'フィルター' },
                domProps: {
                  value: _self.$parent.$parent.$parent.searchKey
                },
                on: {
                  input (e) {
                    _.set(_self, '$parent.$parent.$parent.searchKey', e.target.value)
                  }
                },
                props: {
                  level: {
                    type: Number,
                    required: true
                  }
                }
              }
            )
          }
        }
      ]
    },
    total () {
      return this.filteredItem.length
    },
    filteredItem () {
      const keywords = this.searchKey
        // 全角スペースは半角に変換
        // eslint-disable-next-line no-irregular-whitespace
        .replace(/　/g, ' ')
        .split(' ')
        .filter((str) => str !== '')

      let filteredValue = _.get(this.$refs, 'table.$refs.table.columns[1].filteredValue', null)
      if (filteredValue == null) {
        _.set(this.$refs, 'table.$refs.table.columns[1].filteredValue', [])
        filteredValue = []
      }
      const returnValue = this.searchConfigData.filter((data) => {
        // 公開/個人でのフィルター
        if ((filteredValue.includes(0) && !filteredValue.includes(1) && data.account == null) ||
          (!filteredValue.includes(0) && filteredValue.includes(1) && data.account != null)) {
          return false
        }

        // 検索キーワードでのフィルター
        return keywords.length === 0 ? true : keywords.some((keyword) => {
          return data.name.indexOf(keyword) !== -1
        })
      })

      return common.sortListData(returnValue, this.sortCondition)
    },
    displayItem () {
      const maxPage = Number.parseInt(this.filteredItem.length / 10) + 1
      if (maxPage < this.currentPage) {
        _.set(this, 'currentPage', maxPage)
      }
      const head = (this.currentPage - 1) * 10
      return this.filteredItem.slice(head, head + 10)
    }
  },
  watch: {
    async visible (val) {
      if (val) {
        this.$loadingService.show()
        try {
          // データ取得
          this.searchConfigData = await common.getSearchConditionConfigs(this.functionKey)
          this.dialogVisible = val

          // 表示時にfilteredValueがないため、filterの変更によるcomputedの再計算が行われないため、一度コードで再計算させる
          const tempKeyword = this.searchKey
          this.searchKey = ' '
          setTimeout(() => {
            this.searchKey = tempKeyword
          }, 1)
        } finally {
          this.$loadingService.close()
        }
      }
    },
    dialogVisible (val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    input: function (value) {
      this.model = value
    },
    close () {
      this.dialogVisible = false
    },
    async deleteSearchConfig (row, searchItem) {
      this.$confirm('検索条件設定を削除しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          // APIコール
          const url = config.SEARCH_CONDITION_URL + `/${searchItem.uuid}`
          const method = 'delete'

          await common.apiAxios(url, { method })
          this.searchConfigData = await common.getSearchConditionConfigs(this.functionKey)

          // ダイアログを閉じる
          // this.close()
        } catch (error) {
          common.addError(error, { msg: message.MSG_548() })
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch((error) => {
        if (error === 'cancel') this.$notify.info('キャンセルしました。')
      })
    },
    onRowDoubleClick (row) {

      Object.keys(this.searchConditions).forEach((key) => {

        // 検索条件マスタ
        const c = this.searchConditions[key]

        // 検索条件設定
        const item = row.items.find((item) => item.searchCondition.requestKey === key)

        let display = false
        let value = null

        if (key === 'keyword') {
        // キーワード
          value = item ? item.value : ''
          this.$store.dispatch({
            type: 'set',
            states: {
              [`${this.storePath}/searchKeyword`]: value
            }
          })
        } else if (key === 'isAndSearch') {
        // AND検索
          value = item && item.value === 'true'
          this.$store.dispatch({
            type: 'set',
            states: {
              [`${this.storePath}/isAndSearch`]: value
            }
          })
        } else {
        // それ以外は、値がある場合は表示して、値を取得
          if (item) {
            display = true
            value = item.value
          }
          switch (c.type) {
            case 'NumberRange':
            case 'Date':
            case 'DateTime':
            case 'SingleSelector':
            case 'MultiSelector':
              // 配列に変換
              value = (value || '') === '' ? [] : value.split(',')
              // 数値側の場合、配列を数値に変換
              if (c.valueType === 1) {
                value = value.map((t) => parseInt(t))
              }
              break
            default:
              value = value === null ? '' : value
          }

          // マスタが存在する種別の場合、マスタにない値は除外する
          if (['SingleSelector', 'MultiSelector'].includes(c.type)) {
            value = common.removeUnknownValue(value, this.searchConditions[key].options)
          }

          if (c.type === 'SingleSelector') {
            value = value[0]
          }

          this.$store.dispatch({
            type: 'setValue',
            states: {
              target: this.searchConditions[key],
              key: 'display',
              value: display
            }
          })
          this.$store.dispatch({
            type: 'setValue',
            states: {
              target: this.searchConditions[key],
              key: 'value',
              value: value
            }
          })
        }
      })
      // ダイアログを閉じる
      this.close()
    },
    searcherMethod (value) {
      this.searchKey = value
    },
    onPaginationCurrentChange (val) {
      this.currentPage = val
    },
    onSortChange ({ column, prop, order }) {
      this.sortCondition = {
        // isPublicは、FUNCTIONタイプの並び替えをするためにname(prop)を設定しないようにする必要があるが、
        // フィルターでnameが必要なのでここで判定して設定する値を判定する
        prop: prop === 'isPublic' ? null : prop,
        order,
        sortBy: (!column || !column.sortBy) ? null : column.sortBy
      }
    }
  }
}
</script>
